import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_MESSAGE_QUIET_HOURS } from "@lib/shared_constants";

import type { AppSettingsAppGroupIdQuietHoursRulesDataResult } from "../appSettingsAppGroupIdQuietHoursRulesData";

export interface WorkspaceQuietHoursRuleProps {
  channel: string;
  quiet_time_start: string;
  quiet_time_end: string;
}

export interface PostAppSettingsAppGroupIdQuietHoursRulesProps {
  appGroupId: string;
  rules: WorkspaceQuietHoursRuleProps[];
}

export type PostAppSettingsAppGroupIdQuietHoursRulesResult = AppSettingsAppGroupIdQuietHoursRulesDataResult;

export type WorkspaceQuietHoursRulesUpsertErrors = FetchUserEncodedError<
  SHARED_CONSTANTS_MESSAGE_QUIET_HOURS["ERROR_CODE"]["INVALID_WORKSPACE_QUIET_HOURS_RULES"]
>;

export const isWorkspaceQuietHoursRulesUpsertError = (
  error: FetchRequestError
): error is WorkspaceQuietHoursRulesUpsertErrors => {
  return error instanceof FetchUserEncodedError;
};
